import { render, staticRenderFns } from "./UserReferralReferralsOld.vue?vue&type=template&id=2527918e&scoped=true&"
import script from "./UserReferralReferralsOld.vue?vue&type=script&lang=js&"
export * from "./UserReferralReferralsOld.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralReferralsOld.vue?vue&type=style&index=0&id=2527918e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527918e",
  null
  
)

export default component.exports